import { Input } from "antd";
import React from "react";
import "./CustomCommentInput.scss";

const CustomCommentInput = (props) => {
  return (
    <Input
      className={"custom-comment-input"}
      {...props}
    />
  );
};

export default CustomCommentInput;
